import { render } from "./CarouselConfigView.vue?vue&type=template&id=51c2b698&scoped=true"
import script from "./CarouselConfigView.vue?vue&type=script&lang=js"
export * from "./CarouselConfigView.vue?vue&type=script&lang=js"

import "./CarouselConfigView.vue?vue&type=style&index=0&id=51c2b698&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51c2b698"

export default script